<template>
  <component
    :is="componentType"
    class="button"
    :class="{
      disabled,
      'w-full md:w-auto': smallExpanded,
      'w-full': largeExpanded,
      large,
      small,
      xs,
      secondary,
    }"
    :to="to"
    :href="href"
    :rel="href ? 'noopener' : null"
    :disabled="componentType === 'button' && disabled ? true : null"
  >
    <slot></slot>
  </component>
</template>

<script setup>
import { computed } from 'vue';



const props = defineProps({
  to: [String, Object],
  href: String,
  disabled: Boolean,
  smallExpanded: Boolean,
  largeExpanded: Boolean,
  large: Boolean,
  small: Boolean,
  xs: Boolean,
  secondary: Boolean,
});
const componentType = computed(() => {
  if (props.to) return 'router-link';
  if (props.href) return 'a';
  return 'button';
});
</script>

<style lang="postcss" scoped>
</style>
